export function hasCapitalCaseLetter(value, optional = false){
    if (optional == true && value == null) {
        return true;
    }
    return (/[A-Z]/.test(value)) ? true :false;
}
export function hasNumber(value, optional = false) {
    if (optional == true && value == null) {
        return true;
    }
    return (/\d/.test(value)) ? true : false;
}